import { ObservableQuery } from '@apollo/client/core';
import { OperatorFunction, map } from 'rxjs';

// Apollo Client 4 emits query errors as results instead of failing the
// stream like Apollo Client 3 did. Rethrow them so the existing error
// handling keeps working, and narrow the result to complete data.
export function completeData<T>(): OperatorFunction<ObservableQuery.Result<T>, { data: T }> {
  return map(result => {
    if (result.error) {
      throw result.error;
    }
    return { data: result.data as T };
  });
}
